import { render, staticRenderFns } from "./Celular.vue?vue&type=template&id=44365555&scoped=true"
import script from "./Celular.vue?vue&type=script&lang=js"
export * from "./Celular.vue?vue&type=script&lang=js"
import style0 from "./Celular.vue?vue&type=style&index=0&id=44365555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44365555",
  null
  
)

export default component.exports